let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bdzoF")).then(() => parcelRequire('1ng90'));